import clsx from 'clsx';
import { useSelect } from '../hooks/useCoreContext';
import SelectPills from './SelectPills';
import { twMerge } from 'tailwind-merge';

type TriggerVariant = 'button' | 'combobox';

const TriggerButton = ({
	className,
	text,
	disabled,
	...rest
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
	variant?: TriggerVariant;
	disabled?: boolean;
	text: React.ReactNode;
}) => {
	const { ids, value, getReferenceProps, pillsVariant, isAllActive, selectedOptions } = useSelect();

	const placeHolderClass =
		value === null ||
		value === undefined ||
		value === '' ||
		(Array.isArray(value) && value.length === 0 && !isAllActive)
			? 'text-tertiary'
			: 'text-secondary';

	return (
		<button
			type='button'
			id={ids.trigger}
			{...getReferenceProps()}
			className={twMerge(
				clsx(
					'group first-letter:capitalize',
					'p-0',
					placeHolderClass,
					disabled && 'opacity-50 cursor-not-allowed',
					className,
				),
			)}
			{...rest}
		>
			{pillsVariant && (isAllActive || selectedOptions.length > 0) ? <SelectPills /> : text}
		</button>
	);
};

export default TriggerButton;
